<template>
    <div class="about-us">
      <el-col :span="24" :xs="24" :sm="24" :md="20" :lg="20" :xl="20" class="about-box">
        <el-row class="company-name p-t16" >
            <el-col :span="8" :xs="5" style="   padding: 8px;">
              </el-col>
            <el-col :span="16" :xs="0"  style="    text-align: left;    padding: 8px;">
              <h3>深圳市微影医疗科技有限公司<br></h3>
            </el-col>
        </el-row>
        <el-row style="text-align: left;    padding: 8px; ">
            <el-col :span="8" :xs="24" style="    text-align: right;    padding: 8px;    display: flex;    flex-direction: column;">
                  <el-image style="object-fit: contain;width: 60%;height: auto;    margin: auto;"
                    :src="HlogoURL"
                    fit="contain"></el-image>
            </el-col>
            <el-col :span="16" :xs="24"  style="    text-align: left;    padding: 8px;">
                  <el-row class="p-t16" style="text-align: left;  ">
                      <el-col :span="16" :xs="24"  :sm="0" :md="0" :lg="0" :xl="20" 
                           style="    text-align: left;    padding: 8px;">
                        <h3>深圳市微影医疗科技有限公司<br></h3>
                      </el-col>
                  </el-row>
                  <el-row class="title-item p8">
                    <b>微影医疗</b>
                  </el-row>
                  <el-row style="line-height: 200%;    text-indent: 2rem;">
                    <p>深圳市微影医疗科技有限公司由中科院毕业硕士团队在2020年创立于改革开放与创新的前沿、自贸区、自贸港、粤港澳大湾区核心城市——深圳，公司已入驻中国科学院深圳先进技术研究院与深圳国资委旗下的中科创科平台。
                    </p>
                    <p>微影汇聚了一批拥有从事医疗信息化、图形图像处理、互联网、区块链、信息安全和网络安全经验丰富的专家人才和研发队伍，保障了产品的技术持续先进性。
                    </p>
                    <p>微影自研微影像内核实现基于H5方式的轻量级影像调阅，在任意通网络的终端可实现医学影像的秒级访问。提供区域影像互联互通平台、医共体医学影像平台、远程医学影像诊断服务、一体化医技预约平台、数字胶片运营服务以及医疗云服务技术开发、推广和咨询服务。微影产品全部拥有自主知识产权，已获得多项软件著作权证书，微影智能云影像平台荣获第四届中国（江西）公共安全创新创业大赛二等奖。
                    </p>
                    <p>微影医疗专注于医疗影像平台相关产品的研发、生产、销售和运营，旨在为医疗信息化提供先进的产品和解决方案，为医疗数据互联互通、医疗业务协同、患者健康和医疗卫生监管等应用场景提供全面的技术支撑。
                    </p>
                  </el-row>
                  <el-row style="line-height: 200%;    text-indent: 2rem;">
                    <p>
                        
                    </p>
                  </el-row>
            </el-col>
        </el-row>
        <el-row style="text-align: left; ">
            <el-col :span="8" :xs="6" style="    text-align: right;    padding: 8px;    display: flex;    flex-direction: column;">
                  <el-image style="object-fit: contain;width: 60%;height: auto;    margin: auto;"
                    :src="shuobologoURL"
                    fit="contain"></el-image>
            </el-col>
            <el-col :span="16" :xs="18"  style="    text-align: left;    padding: 8px;">
                  <el-row class="title-item p-t8">
                    <b>硕博微影</b>
                  </el-row>
                  <el-row style="line-height: 200%;    text-indent: 2rem;">
                    <p class="p-b32">
                      硕博微影是由总部分别设立在南昌和深圳的江西硕博科技有限公司、深圳市微影医疗科技有限公司联合运营中心，专注于医疗影像研发、生产、销售和运营，旨在实现江西本地化的运营和服务，更好地服务江西医疗机构和就诊患者。
                    </p>
                  </el-row>
            </el-col>
        </el-row>
      </el-col>
    </div>
</template>
<script>
export default {
  name: "about-us",
  data() {
    return {
      HlogoURL:require('@/assets/logo/logo_pic-text.svg'),
      shuobologoURL:require('@/assets/logo/shuobo_pic-text.svg'),
      };  
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.about-us {
    background: var(--WhiteColor-1);
    height: 100%;
    margin-top: 8px;
    font-size: 14px;
    justify-content: center;
    display: flex;
    overflow: auto;
}
.about-us .about-us-box {
    /* width: 100%; */
    height: 100%;
  color: var(--BlackColor-1);
  /* overflow: auto; */
}
.about-us .about-us-box .company-name {
  display: block;
}
/* @media only screen and (max-width: 768px) {
  .about-us .about-us-box .company-name {
    display: none;
    text-align: left;
  }
} */
.about-us .about-us-box .company-name2 {
  display: none;
}
/* @media only screen and (min-width: 768px) {
  .about-us .about-us-box .company-name2 {
    display: block;
    text-align: left;
  }
} */
</style>